import React from 'react';

const TransactionHeader = ({isMobile}) => (
    <tr className="row-details-header transaction-header">
        <td className="hidden-sm hidden-xs" colSpan={2}>Description</td>
        <td className="hidden-sm hidden-xs">Date</td>
        <td colSpan={isMobile ? 5 : 1}>Amount</td>
        <td>Actions</td>
    </tr>
);

export default TransactionHeader;



// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/transaction-header.js